module.exports = __webpack_public_path__ + "static/media/ize.d3fd0f33.svg";